var map = {
	"./AEDC-LOGO.svg": "a260",
	"./AEDC.svg": "b0b6",
	"./AIRTEL.svg": "a5ac",
	"./DSTV.svg": "cd7f",
	"./EEDC.svg": "3147",
	"./EKEDC.svg": "8558",
	"./GLO.svg": "592c",
	"./GOTV.svg": "7512",
	"./IBEDC.svg": "6355",
	"./IE.svg": "2dde",
	"./JEDC.svg": "3f0e",
	"./KAEDC.svg": "fb2a",
	"./KE.svg": "6b7c",
	"./MTN-LOGO.svg": "9055",
	"./MTN.svg": "d2c0",
	"./NINEMOBILE.svg": "fe0b",
	"./PHED.svg": "ae55",
	"./SHOWMAX.svg": "9839",
	"./STARTIMES.svg": "4a4ba",
	"./YEDC.svg": "4fb2",
	"./airtime-call.svg": "f3f2",
	"./bills-icon.svg": "48ae",
	"./cable-tv.svg": "388e",
	"./data-internent.svg": "5bb3",
	"./electricity-bulb.svg": "08a5",
	"./paystack.svg": "6b1d",
	"./safe-logo.svg": "9969",
	"./success-check.svg": "928a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a235";